import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  Button,
  Card,
  IconButton,
  Modal,
  Stack,
  Typography,
  TextField,
  Switch,
  FormControlLabel,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import BackdropUI from "../../../ui/Backdrop";
import PropTypes from "prop-types";
import { addExternalLinkApi } from "../../../store/event-module/externallink/addexternallink";
import { updateExternalLinkApi } from "../../../store/event-module/externallink/updateexternallink";
import { eventObjectsApi } from "../../../store/event-module/assignObjectToChannel";
import { useDispatch, useSelector } from "react-redux";

export default function AddExternalLink({ open, setOpen, back, refreshList, event_id, closeExternalLink, externalLinkDetail }) {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [backdrop, setBackDrop] = useState(false);

  const handleClose = () => {
    closeExternalLink()
    setOpen(false);
    reset();
  };

  const onSubmit = async (data) => {
    setBackDrop(true);
    if (!externalLinkDetail) {
      dispatch(addExternalLinkApi({ ...data, is_published: true })).then((action) => {
        if (!action.type.includes("rejected")) {
          dispatch(eventObjectsApi({
            content_type: "externallink",
            object_id: action?.payload?.result?.id,
            event: event_id,
            is_published: data?.is_published
          })).then(
            (action) => {
              if (!action.type.includes("rejected")) {
                refreshList()
                handleClose();
                setBackDrop(false)
              }
            }
          )
        }
      }).catch(err => console.log(err))
    } else {
      dispatch(updateExternalLinkApi({ ...data, ID: externalLinkDetail?.object_data?.id })).then((action) => {
        if (!action.type.includes("rejected")) {
          refreshList();
          handleClose();
          setBackDrop(false)
        }
      }).catch(err => console.log(err))
    }
  };

  useEffect(() => {
    let defalutValues = {};
    defalutValues["title"] = externalLinkDetail?.object_data?.title
    defalutValues["url"] = externalLinkDetail?.object_data?.url
    defalutValues["points"] = externalLinkDetail?.object_data?.point
    defalutValues["is_published"] = externalLinkDetail?.is_published
    reset(defalutValues);
  }, [externalLinkDetail, reset]);
  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Card className="modal" sx={{ p: 3, width: 420 }}>
          <Stack spacing={2}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography fontWeight={600}>{!externalLinkDetail ? "Add" : "Update"} External Link</Typography>

              <IconButton onClick={handleClose}>
                <HighlightOffIcon />
              </IconButton>
            </Stack>

            <form onSubmit={handleSubmit(onSubmit)}>
              <Stack spacing={2}>
                <TextField
                  label="Title"
                  fullWidth
                  {...register("title", { required: "Title is required" })}
                  error={!!errors.title}
                  helperText={errors.title?.message}
                />

                <TextField
                  label="URL"
                  fullWidth
                  {...register("url", { required: "URL is required" })}
                  error={!!errors.url}
                  helperText={errors.url?.message}
                />

                <TextField
                  label="Points"
                  type="number"
                  fullWidth
                  {...register("points", { required: "Points required" })}
                  error={!!errors.points}
                  helperText={errors.points?.message}
                />

                <FormControlLabel
                  control={<Switch defaultChecked {...register("is_published")} />}
                  label="Publish immediately"
                />

                <Button variant="contained" type="submit">
                  {!externalLinkDetail ? "Create" : "Update"} External Link
                </Button>
              </Stack>
            </form>
          </Stack>
        </Card>
      </Modal>

      <BackdropUI open={backdrop} />
    </>
  );
}

AddExternalLink.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  back: PropTypes.func,
  refreshList: PropTypes.func,
};